import request from '@/utils/request'
export function Login(data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}
// // 重置密码
export function reset(data) {
    return request({
        // url: '/reset',
        url: '/v1/admin/forgetPwd',
        method: 'post',
        data
    })
}

// 获取验证码
export function code(data) {
    return request({
        url: '/code',
        method: 'post',
        data
    })
}

// 发送验证码邮件
export function sendCodeEmail(data) {
    return request({
        url: '/v1/admin/sendCodeEmail',
        method: 'post',
        data
    })
}